import { provideSoftAppsModule, withSoftAppsModuleRoutes } from '@softapps/core';
import { getModuleGroupById } from '@softline/application';
import { provideGarageReportGlobals } from './report.globals';
import { garageReportRoutes } from './report.routes';

export function provideGarageReport() {
  return [
    provideSoftAppsModule(
      {
        name: 'garage-report',
        title: 'Werkstattbericht',
        icon: 'fa-regular fa-file-invoice',
        route: '/garage-report',
        color: 'bg-accent text-white',
        permission: 'GARAGE.REPORT',
        group: getModuleGroupById(11),
      },
      withSoftAppsModuleRoutes({ app: garageReportRoutes })
    ),
    ...provideGarageReportGlobals(),
  ];
}
